import { render, staticRenderFns } from "./SettingPosture.vue?vue&type=template&id=117ec4e0&scoped=true&"
import script from "./SettingPosture.vue?vue&type=script&lang=js&"
export * from "./SettingPosture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ec4e0",
  null
  
)

export default component.exports